import React from 'react';
import { ActionCreators as UndoActionCreators } from 'redux-undo';
import { connect } from 'react-redux';

let UndoRedo = ({
  canUndo,
  canRedo,
  onUndo,
  onRedo
}) => /*#__PURE__*/React.createElement("div", {
  className: "btn-group",
  role: "group"
}, /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: "btn btn-secondary btn-sm",
  onClick: onUndo,
  disabled: !canUndo
}, "\u21B6 Undo"), /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: "btn btn-secondary btn-sm",
  onClick: onRedo,
  disabled: !canRedo
}, "Redo \u21B7"));

const mapStateToProps = state => ({
  canUndo: state.past.length > 0,
  canRedo: state.future.length > 0
});

const mapDispatchToProps = {
  onUndo: UndoActionCreators.undo,
  onRedo: UndoActionCreators.redo
};
UndoRedo = connect(mapStateToProps, mapDispatchToProps)(UndoRedo);
export default UndoRedo;